import AbstractProvidedClass from "../../shared/AbstractProvidedClass";
import EventTypes from "../../shared/EventTypes";
import SpeciesList from "./SpeciesList";

export default class Input extends AbstractProvidedClass {
    inputs = [];
    inputSets = {
        'ellipse': [],
        'rectangle': [],
        'polygon': [],
        'line': [],
    };

    constructor(provider, tabContainer) {
        super(provider);

        this.container = this.p.createDiv().parent(tabContainer);

        this.createTitle();
        this.createLabel();
        this.createLayer();
        this.createSpeciesList();
        this.createNotes();
        this.createDimensions();

        this.hide();
    }

    setElement(element) {
        this.inputs.map(([input, setter]) => {
            if (this.inputSets[element.type].includes(input)) {
                input.show();
                setter(element);
            } else {
                input.hide();
            }
        });
    }

    registerInput(input, setter, types = ['ellipse', 'rectangle', 'polygon', 'line']) {
        input.parent(this.container);
        this.inputs.push([input, setter]);
        types.map((type) => {
            this.inputSets[type].push(input);
        });
        input.hide();
    }

    createTitle() {
        const title = this.p.createElement('h3', '').style('margin', 0);
        this.registerInput(
            title,
            (element) => title.html(element.name),
        );
    }

    createLabel() {
        const label = this.p.createDiv().class('input-group');
        const labelDivs = [];
        this.registerInput(
            label,
            (element) => {
                const labels = element.labels.getAllLabels();
                if (labels.length > 0) {
                    label.show();
                    const max = labels.length > labelDivs.length ? labels.length : labelDivs.length;
                    for (let i = 0; i < max; i++) {
                        let div = labelDivs[i];
                        if (!div) {
                            div = this.p.createDiv('').parent(label);
                            labelDivs.push(div);
                        }
                        if (i < labels.length) {
                            div.html(labels[i]);
                        } else {
                            div.html('');
                        }
                    }
                } else {
                    label.hide();
                }
            }
        );
    }

    createNotes() {
        const notes = this.p.createDiv();
        this.p.createElement('h3', 'Notes')
            .parent(notes)
            .style('margin-bottom', '0px');
        const input = this.p.createDiv('').parent(notes);
        this.registerInput(
            notes,
            (element) => {
                if (element.notes) {
                    notes.show();
                    input.html(element.notes);
                } else {
                    notes.hide();
                }
            }
        );
    }

    createDimensions() {
        this.dimensions = this.p.createElement('h3', 'Dimensions')
            .style('margin-bottom', '0px');
        this.registerInput(this.dimensions, () => { });

        this.createSize();
        this.createWidth();
        this.createHeight();
        this.createMultiInput();
    }

    createSpeciesList() {
        this.speciesLabelList = SpeciesList.setup(this.provider)
            .make();
        this.registerInput(this.speciesLabelList, (element) => this.speciesLabelList.populate(element));
    }

    createLayer() {
        const layer = this.p.createDiv();
        const layerLabel = this.p.createElement('h3', 'Layer')
            .parent(layer)
            .style('margin-bottom', '0px');
        const input = this.p.createDiv('').parent(layer);
        this.registerInput(layer, (element) => {
            if (element.layer) {
                layer.show();
                input.html(element.layer.name);
            } else {
                layer.hide();
            }
        });
    }

    createSize() {
        let [size, sizeInput] = this.createSimpleInput('Size:');
        this.registerInput(
            size,
            (element) => sizeInput.html(element.displaySize),
            ['ellipse'],
        );
    }

    createWidth() {
        let [width, widthInput] = this.createSimpleInput('Width:');

        this.registerInput(
            width,
            (element) => widthInput.html(element.displayWidth),
            ['rectangle'],
        );
    }

    createHeight() {
        let [height, heightInput] = this.createSimpleInput('Height:');
        this.registerInput(
            height,
            (element) => heightInput.html(element.displayHeight),
            ['rectangle'],
        );
    }

    createMultiInput() {
        let container = this.p.createDiv().style('margin-top', '5px');
        let inputs = [];
        let getMultiInput = (index) => {
            let input = inputs[index];
            if (!input) {
                input = this.createSimpleInput(`Side ${index + 1} length:`);
                input[0].parent(container);
                inputs.push(input);
            }
            return input;
        }
        let setter = (element) => {
            inputs.map((input) => {
                input[1].html('');
                input[0].hide();
            });
            for (let i = 0; i < element.length; i++) {
                let input = getMultiInput(i);
                input[1].html(element.segmentLength(i));
                input[0].show();
                input[0].elt.onmouseover = () => element.hoverSegment(i);
                input[0].elt.onmouseout = () => element.hoverSegment(null);
            }
        }
        this.registerInput(container, setter, ['polygon', 'line']);
    }

    createSimpleInput(labelText) {
        let container = this.p.createDiv().class('input-group')
            .style('margin-top', '5px');
        let label = this.p.createDiv(labelText).parent(container)
            .class('input-label');

        let input = this.p.createDiv('').parent(container)
            .style('display', 'inline-block')
            .style('margin-left', '5px');

        let unit = this.p.createDiv(" (m)").parent(container)
            .style('display', 'inline-block')
            .style('margin-left', '5px');

        this.on(EventTypes.UPDATE_UNIT_SYSTEM, (isMetric) => unit.html(isMetric ? ' (m)' : ' (ft)'));

        return [container, input];
    }

    show() {
        this.container.show();
    }

    hide() {
        this.container.hide();
    }
}
